<template>
<div class="chapter">
<div class="inner_page">
<p class="calibre_6" id="filepos18507"><span class="calibre6"><a></a>First Sentient Publications edition, 2003</span></p>
<p class="calibre_2"><span class="calibre6">Copyright © 2003 by Kegan Paul Limited.</span></p>
<p class="calibre_2"><span class="calibre6">Grateful acknowledgment is made for permission to use Matt Errey’s editorial notes.</span></p>
<p class="calibre_2"><span class="calibre6">All rights reserved. This book, or parts thereof, may not be reproduced in any form without permission, except in the case of brief quotations embodied in critical articles and reviews.</span></p>
<p class="calibre_2"><span class="calibre6"><em class="italic">Cover design by Kim Johansen, Black Dog Design<br class="calibre1"/>Book design by Anna Bergstrom</em></span></p>
<p class="calibre_2"><span class="calibre6"><span class="bold">Library of Congress Cataloging-in-Publication Data</span></span></p>
<p class="calibre_7"><span class="calibre6">Wei, Wu Wei.</span></p>
<p class="calibre_8"><span class="calibre6">Why Lazarus laughed : the essential doctrine Zen--Advaita--Tantra.--1st ed.</span></p>
<blockquote class="calibre_9"><p class="calibre_10"><span class="calibre6">p. cm.</span></p></blockquote>
<p class="calibre_8"><span class="calibre6">Includes index.</span></p>
<p class="calibre_8"><span class="calibre6">ISBN 978-1-59181-226-5</span></p>
<p class="calibre_11"><span class="calibre6">1. Asia—Religion. 2. Philosophy, Asian. 3. Advaita. I. Title.</span></p>
<p class="calibre_11"><span class="calibre6">BL1033 .W45 2003</span></p>
<p class="calibre_11"><span class="calibre6">202--dc22</span></p>
<p class="calibre_12"><span class="calibre5">                                                                           2003016343</span></p>
<p class="calibre_2"><span class="calibre5">SENTIENT PUBLICATIONS</span></p>
<p class="calibre_5"><span class="calibre6">A Limited Liability Company<br class="calibre1"/>PO BOX 1851<br class="calibre1"/>BOULDER CO 80306<br class="calibre1"/><a href="http://www.sentientpublications.com" target="_blank">www.sentientpublications.com</a></span></p> <div class="mbp_pagebreak" id="calibre_pb_5"></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_004.vue?2dd3e577